import { render, staticRenderFns } from "./managePallets.vue?vue&type=template&id=95b74f8c&"
import script from "./managePallets.vue?vue&type=script&lang=js&"
export * from "./managePallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports